export const CHANGE_DATE = 'CHANGE_DATE';
export const FETCH_DAILY_COURSES = 'FETCH_DAILY_COURSES';



// WEBPACK FOOTER //
// ./src/store/calendar/types.js